export default "<p>retour-bon-transfert works!</p>\n"